import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Casting.css";

import img43 from "../assets/img43.jpg";
import img44 from "../assets/img44.jpg";
import img45 from "../assets/img45.jpg";
import img46 from "../assets/img46.jpg";
import img47 from "../assets/img47.jpg";
import img48 from "../assets/img48.jpg";
import img49 from "../assets/img49.jpg";
import img50 from "../assets/img50.jpg";
import img51 from "../assets/img51.jpg";
import img52 from "../assets/img52.jpg";
import img53 from "../assets/img53.jpg";
import img54 from "../assets/img54.jpg";
import img55 from "../assets/img55.jpg";
import img56 from "../assets/img56.jpg";
import img57 from "../assets/img57.jpg";
import img58 from "../assets/img58.jpg";

const instruments = [
  {
    title: "Spectrometer",
    img: img43,
    specs: ["Make: Spectro (Ametek)", "Model: S02", "No. of elements: 32"]
  },
  {
    title: "Vacuum density tester",
    img: img44,
    specs: ["Make: MK instruments", "Model: MK 3VT / MK 3000"]
  },
  {
    title: "Radioactive check meter",
    img: img45,
    specs: ["Make: Nucleonix", "Model: RC 705E"]
  },
  {
    title: "Tensometer Tensile machine",
    img: img46,
    specs: ["Make: Kudale", "Model: PC 2000"]
  },
  {
    title: "Brinell hardness tester",
    img: img47,
    specs: ["Make: FIE", "Model: 3000 PC"]
  },
  {
    title: "Microscope image Analyser",
    img: img48,
    specs: ["Make: Leica", "Model: DM 2700M"]
  },
  {
    title: "X-ray machine",
    img: img49,
    specs: ["Make: Baker Hughes", "Model: X-cube XL"]
  },
  {
    title: "CMM",
    img: img50,
    specs: ["Make: Accurate CMM", "Model: Mega"]
  },
  {
    title: "FARO 3D scanner",
    img: img51,
    specs: ["Make: Faro Laser 3D Scan", "Model: Arm Quantum m max"]
  },
  {
    title: "Ultrasonic Thickness gauge",
    img: img52,
    specs: ["Make: Olympus", "Model: 38DL"]
  },
  {
    title: "Endoscope",
    img: img53,
    specs: ["Make: MITCORP", "Model: X1000"]
  },
  {
    title: "Thermal camera",
    img: img54,
    specs: ["Make: FLIR", "Model: E60"]
  },
  {
    title: "Calorimeter dye coat",
    img: img55,
    specs: ["Make: Lomotto", "Model: DC1500 UDV"]
  },
  {
    title: "Hot strength tester (Resin sand)",
    img: img56,
    specs: ["Make: Versatile", "Model: VHTD"]
  },
  {
    title: "Core gas tester (Resin sand)",
    img: img57,
    specs: ["Make: Versatile", "Model: VCG"]
  },
  {
    title: "Grain fineness tester (Resin sand)",
    img: img58,
    specs: ["Make: Versatile", "Model: VGH"]
  }
];

function Casting() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: true,
    centerMode: true,
    centerPadding: "60px", 
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          centerPadding: "100px"
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          centerPadding: "40px"
        }
      }
    ]
  };

  return (
    <div className="slider-container">
      <Slider {...settings}>
        {instruments.map((item, index) => (
          <div className="card" key={index}>
            <h2>{item.title}</h2>
            <img src={item.img} alt={item.title} />
            <div className="specs">
              <h3>Specifications</h3>
              {item.specs.map((s, i) => (
                <p key={i}>{s}</p>
              ))}
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default Casting;
